<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="content-section intro-section">
    <h2 class="section-title">Assurance Auto Temporaire</h2>
    <div class="intro-content">
      <p>
        Si vous êtes à la recherche de ce type d'<strong>assurance Auto Temporaire</strong>, merci de prendre contact avec nous car il existe beaucoup trop de déclinaisons selon votre situation personnelle.
      </p>
      <p>
        En cas de besoin d'une assurance annuelle de votre véhicule professionnel ou véhicule personnel, il est sans doute conseillé d'assurer le véhicule via une <a href="/assurance-auto-particuliers" class="link-purple">Assurance Auto Personnelle</a>, ou une <a href="/assurance-auto-professionnelle" class="link-purple">Assurance Auto Professionnelle</a>.
      </p>
      <p>
        Le courtier en Assurance BROKINS est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong>J.LASSUR, NETVOX</strong>
      </p>

      
      <div class="iframe-devis">
        <iframe frameborder="0" height="1000" width="500" src="https://www.jlassure.com/sousfiche/assure_tempo_rapide_mb.php?cat=&amp;&amp;tip=09.73.45.48.98&amp;&amp;id=1180&amp;&amp;cd=18BEL444&amp;&amp;adrsite=https://www.brokins.fr/devis-assurance-auto-temporaire/">Votre navigateur ne supporte pas les IFrames.</iframe>
      </div>

      <div class="cta-box">
        <a href="/contact" class="btn-devis">Devis en ligne</a>
      </div>
    </div>
  </div>

</app-page-layout>
